import React, { Component } from "react";

class CategoryFilter extends Component {
  render() {
    return (
      <div>
        {this.props.rowsCount === 1 ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 4.5002C1 1.90788 1.02741 1.0224 4.3711 1.00061C4.41353 1.00033 10.4503 1 10.4938 1C10.5373 1 15.5934 1.00033 15.6358 1.00061C18.9795 1.0224 19.0069 1.90788 19.0069 4.5002C19.0069 7.09198 19.0177 7.97764 15.6393 7.99977C15.5957 8.00006 10.5546 8.0002 10.5099 8.0002C10.4652 8.0002 4.41116 8.00006 4.36759 7.99977C0.989208 7.97764 1 7.09199 1 4.5002Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 15.5002C1 12.9079 1.02741 12.0224 4.3711 12.0006C4.41353 12.0003 10.4503 12 10.4938 12C10.5373 12 15.5934 12.0003 15.6358 12.0006C18.9795 12.0224 19.0069 12.9079 19.0069 15.5002C19.0069 18.092 19.0177 18.9776 15.6393 18.9998C15.5957 19.0001 10.5546 19.0002 10.5099 19.0002C10.4652 19.0002 4.41116 19.0001 4.36759 18.9998C0.989208 18.9776 1 18.092 1 15.5002Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 4.5C1 1.87479 1.02811 1 4.5 1C7.97189 1 8 1.87479 8 4.5C8 7.12521 8.01107 8 4.5 8C0.988927 8 1 7.12521 1 4.5Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 4.5C12 1.87479 12.0281 1 15.5 1C18.9719 1 19 1.87479 19 4.5C19 7.12521 19.0111 8 15.5 8C11.9889 8 12 7.12521 12 4.5Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 15.5C1 12.8748 1.02811 12 4.5 12C7.97189 12 8 12.8748 8 15.5C8 18.1252 8.01107 19 4.5 19C0.988927 19 1 18.1252 1 15.5Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 15.5C12 12.8748 12.0281 12 15.5 12C18.9719 12 19 12.8748 19 15.5C19 18.1252 19.0111 19 15.5 19C11.9889 19 12 18.1252 12 15.5Z"
              stroke="#130F26"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        )}
      </div>
    );
  }
}

export default CategoryFilter;
